import { FormTextInput } from '@src/common/components/FormTextInput';
import { Stack } from '@src/common/components/Stack';
import { theme } from '@src/common/styles/Theme';
import type { CollapseListener } from '@src/orders/CollapseListener';
import { EditOrderCollapsible } from '@src/orders/EditOrderCollapsible';
import type { FormEntries } from '@src/orders/FormEntries';
import { useSectionError } from '@src/orders/hooks/useSectionError';
import { ConditionalField } from '@src/orders/PermitFormSections/ConditionalField';
import { CommentsField, commentsFields } from '@src/permitField/CommentsFields';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

type Props = { fields: string[] } & CollapseListener;

export const Comments = (props: Props) => {
  const { t } = useTranslation();
  const {
    register,
    formState: { errors },
  } = useFormContext<FormEntries<typeof props.fields>>();

  const { sectionInError } = useSectionError(Object.keys(commentsFields));

  if (props.fields.length <= 0) {
    return null;
  }

  return (
    <EditOrderCollapsible
      title={t('comments')}
      id="comments-section"
      collapseEventName={props.collapseEventName}
      uncollapseEventName={props.uncollapseEventName}
      inError={sectionInError}
    >
      <Stack gap={theme.spacing['3']}>
        <ConditionalField
          fields={props.fields}
          conditions={CommentsField.fieldName}
        >
          <FormTextInput
            register={register}
            errors={errors}
            disabled={false}
            fieldName={CommentsField.fieldName}
            multiline
          />
        </ConditionalField>
      </Stack>
    </EditOrderCollapsible>
  );
};
